import { menuTypes } from "../constants/action-types";
import { myReducerPersist } from "../store/managerLocalStorage";

const initialState = {
  menu: [],
};

const menuReducer = (state = initialState, action) => {
  switch (action.type) {
    case menuTypes.SET_MENU:
      return {
        ...state,
        menu: action.data,
      };
    case menuTypes.REMOVE_MENU:
      return initialState;
    default:
      return state;
  }
};

export default myReducerPersist({ key: "user-menu" }, menuReducer);
